// fork overlay: fork-owned helper (conversation pipeline kanban) — no OSS counterpart.
// Single source of truth for the well-known custom attribute that backs the board.
// The board renders one column per value of the account's `pipeline_stage`
// conversation attribute (display type `list`); a conversation's current stage is
// `conversations.custom_attributes['pipeline_stage']`.
export const PIPELINE_STAGE_KEY = 'pipeline_stage';

// THE definition of "this attribute backs the board" — keep the sidebar gate
// and the board itself on this one predicate so they can never disagree.
export const isStageAttribute = attribute =>
  attribute.attributeKey === PIPELINE_STAGE_KEY &&
  attribute.attributeDisplayType === 'list';

export const findStageAttribute = attributes =>
  attributes.find(isStageAttribute);

// Bus events relayed from the fork ActionCable overlay so the board can react
// to remote changes without a store round-trip. CONVERSATION_UPDATED fires for
// both conversation.updated and conversation.created (an API-created deal can
// start life with a stage); MESSAGE_CREATED keeps loaded card previews live.
export const PIPELINE_CONVERSATION_UPDATED = 'pipeline.conversation.updated';
export const PIPELINE_MESSAGE_CREATED = 'pipeline.message.created';
export const PIPELINE_MESSAGE_UPDATED = 'pipeline.message.updated';

// Payload for POST /api/v1/accounts/:id/conversations/filter — one column fetch.
// `equal_to` on a list attribute compiles to a case-insensitive text match
// (Filters::CustomAttributeFilterHelper), so stage values round-trip as-is.
export const buildStageFilterQuery = stage => ({
  payload: [
    {
      attribute_key: PIPELINE_STAGE_KEY,
      custom_attribute_type: 'conversation_attribute',
      filter_operator: 'equal_to',
      values: [stage],
      query_operator: null,
    },
  ],
});

// Camelize a conversation payload for components-next consumers while keeping
// `custom_attributes` hashes byte-identical — the update endpoint REPLACES the
// whole hash, so stage writes must merge over the original (snake_case) keys.
export const CONVERSATION_CAMELIZE_OPTIONS = {
  deep: true,
  stopPaths: [
    'custom_attributes',
    'additional_attributes',
    'meta.sender.custom_attributes',
    'meta.sender.additional_attributes',
  ],
};
